import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Booking } from 'app/shared/models/booking.model';



@Injectable()
export class KmPassService {
    public onSavePassengerOptions: Subject<void>;
    public onChangeFarePriceKMS: Subject<number>;
    constructor() {
        this.onSavePassengerOptions = new Subject<void>();
        this.onChangeFarePriceKMS = new Subject<number>();
    }
    broadcastSavePassengerOptions(): any {
        this.onSavePassengerOptions.next();
    }
    broadcastFarePriceKMS(farePriceKMS: number): any {
        this.onChangeFarePriceKMS.next(farePriceKMS);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/km-pass.service.ts